import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageSquareFallback = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 80 80",
	id: "image-square-fallback_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#F2EDE9",
		d: "M0 0h80v80H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#7C766E",
		fillRule: "evenodd",
		d: "M29.467 22.903c-3.254.368-5.549 3.385-5.018 6.598a5.71 5.71 0 0 0 9.567 3.23 5.7 5.7 0 0 0 1.673-5.269 5.72 5.72 0 0 0-4.477-4.477 6.2 6.2 0 0 0-1.745-.082m14.506 12.718c-.295.096-.56.275-.706.478-.047.066-1.617 2.617-3.49 5.67-2.082 3.395-3.448 5.597-3.518 5.668a.8.8 0 0 1-.499.226.83.83 0 0 1-.508-.228c-.061-.063-.678-1.028-1.372-2.144-1.392-2.241-1.397-2.247-1.786-2.438a1.4 1.4 0 0 0-1.153-.045c-.19.072-.445.255-.56.402-.119.151-8.234 12.748-8.314 12.906a.8.8 0 0 0-.024.573.95.95 0 0 0 .36.389l.112.06 17.424.007c11.742.004 17.458-.003 17.527-.021a.8.8 0 0 0 .45-.357.54.54 0 0 0 .084-.342.55.55 0 0 0-.084-.343 9508 9508 0 0 0-12.389-19.907 1.44 1.44 0 0 0-.784-.562 1.65 1.65 0 0 0-.77.008",
		clipRule: "evenodd"
	})]
});
export { SvgImageSquareFallback as ReactComponent };
